




















import { Component, Prop, Vue } from "vue-property-decorator";
import { countryCodes } from "@/config/user/citizenship";
import { VueSelect } from "vue-select";
import { IRole } from "@/@types/admin/staff";

@Component({ components: { "v-select": VueSelect } })
export default class StaffRoles extends Vue {
  @Prop({ type: String, default: "" }) role!: string;
  @Prop({ type: Array, default: () => [] }) roles!: Array<IRole>;
  countryCodes = countryCodes;
  select: Element | null = null;

  get roleList(): Array<string> {
    const arr: Array<string> = [];
    this.roles.forEach((c) => arr.push(this.$getLocale(c.name)));
    return arr;
  }

  get post(): string {
    const post = this.roles.find((el) => el._id == this.role);
    return post ? this.$getLocale(post.name) : "";
  }

  change(name: string): void {
    const role = this.roles.find((r) => this.$getLocale(r.name) == name);
    if (role) {
      this.$emit("change", role._id);
    }
  }
}
